/* eslint-disable react/jsx-wrap-multilines */
import React, { useState, useEffect } from 'react';
import { connect, history } from 'umi';

import { Progress } from 'antd';
import { isEmpty } from 'lodash';

import { Radio, Button, Modal, Text } from '@digitalc/dxp-ui';
import { onHistoryPush, getDate } from '@/utils/utils';

import useGCPI18n from '@/hooks/useGCPI18n';
import { BaseSpin } from '@/components';
import redeemTitle from '@/assets/images/point/redeemTitle.png';
import convertFail from '@/assets/images/point/convertFail.png';
import rewardDate from '@/assets/images/reward_date.svg';

import Header from '../Header';

import styles from './index.less';

const RedeemList = props => {
  const { voucherDetail, loading, dispatch } = props;
  const {
    couponName,
    couponSn,
    redeemType,
    redeemStartTime,
    redeemEndTime,
    expDate,
    effDate,
    availableRedeemList = [],
  } = voucherDetail;

  const onlyChooseOne = redeemType === 'S';

  const GCPI18n = useGCPI18n();

  const [confirmVisible, setConfirmVisible] = useState(false);
  const [hasFail, setHasFail] = useState(false);
  const [offerList, setOfferList] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState({}); // 单选选中的数据
  const goBack = () => {
    history.goBack();
  };

  const handleSubmit = () => {
    setConfirmVisible(true);
  };

  const handleSelect = (detail, checked) => {
    // 单选
    setSelectedOffer(checked ? {} : detail);
  };

  const handleRedeem = async () => {
    setConfirmVisible(false);
    // 调用接口兑换数据 pointShop/redeemCoupon
    let redeemObjList = [];
    let renderList = [];
    if (onlyChooseOne) {
      // 单选
      redeemObjList = [
        {
          objType: selectedOffer.objType,
          objCode: selectedOffer.objCode,
        },
      ];
      renderList = [
        {
          label: `${GCPI18n({ id: 'lb_prize_voucher' })} 1`,
          value: selectedOffer.offerName,
        },
      ];
    } else {
      // 全选，排除没有额度的
      offerList.forEach(it => {
        if (!it.noAmount) {
          redeemObjList.push({
            objType: it.objType,
            objCode: it.objCode,
          });
          renderList.push({
            label: `${GCPI18n({ id: 'lb_prize_voucher' })} ${renderList.length + 1}`,
            value: it.offerName,
          });
        }
      });
    }
    const res =
      (await dispatch({
        type: 'pointShop/redeemCoupon',
        payload: {
          redeemObjList,
          couponSn,
        },
      })) || {};
    const isSuccess = !isEmpty(res);
    if (isSuccess) {
      onHistoryPush('/pointshop/successful', null, {
        needDetail: false,
        renderList,
        btnText: GCPI18n({ id: 'lb_back_my_voucher' }),
        backUrl: '/pointshop/myVoucher',
      });
    } else {
      setHasFail(true);
    }
  };

  const handleTryAgain = () => {
    setConfirmVisible(false);
  };

  const queryDetail = async () => {
    const codes = availableRedeemList.map(it => it.objCode);
    const data =
      (await dispatch({
        type: 'pointShop/queryCouponOfferList',
        payload: {
          offerNbrs: codes.join(','),
        },
      })) || [];
    const newList = [];
    availableRedeemList.forEach(it => {
      const offerDetail = (data || []).find(i => i.offerNbr === it.objCode) || {};
      const noAmount = Number(it.availableAmount) <= 0;
      if (!isEmpty(offerDetail)) {
        const newDetail = {
          ...it,
          noAmount,
          ...offerDetail,
        };
        newList.push(newDetail);
      }
    });
    setOfferList(newList);
  };

  // 删除html标签
  const deleteHtml = str => {
    if (typeof str !== 'string') return str;
    let result = '';
    let i = 0;
    while (i < str.length) {
      if (str[i] === '<') {
        // 跳过标签内容，找到对应的 >
        const closeIdx = str.indexOf('>', i + 1);
        if (closeIdx !== -1) {
          i = closeIdx + 1;
        } else {
          result += str[i];
          i += 1;
        }
      } else {
        result += str[i];
        i += 1;
      }
    }
    return result;
  };

  useEffect(() => {
    if (!isEmpty(availableRedeemList)) {
      queryDetail();
    }
  }, [availableRedeemList]);

  return (
    <div className={styles.redeemListPage}>
      <Header
        title={GCPI18n({
          id: 'lb_voucher_redeem_title',
        })}
        goHome={goBack}
      />
      <BaseSpin spinning={loading}>
        <div className={styles.contain}>
          <div className={styles.bannerBox}>
            <div className={styles.banndeDetail}>
              <div className={styles.label}>{GCPI18n({ id: 'lb_voucher_name' })}</div>
              <div className={styles.value}>{couponName}</div>
              <div className={styles.time}>
                <img src={rewardDate} alt="" />
                {getDate(effDate, redeemStartTime)} - {getDate(expDate, redeemEndTime, true)}
              </div>
            </div>
            <div className={styles.imgBox}>
              <img src={redeemTitle} alt="redeemTitle" />
            </div>
          </div>
          <div className={styles.listBox}>
            <div className={styles.listTitle}>
              {GCPI18n({ id: onlyChooseOne ? 'tip_redeem_choose_one' : 'tip_redeem_choose_all' })}
            </div>
            <ul>
              {offerList.map(it => {
                const {
                  availableAmount,
                  totalAmount,
                  offerName,
                  offerNbr,
                  brief,
                  thumbnail,
                  noAmount,
                } = it;
                const percent = (availableAmount / totalAmount) * 100;
                const checked = !isEmpty(selectedOffer) && selectedOffer.offerNbr === offerNbr;
                return (
                  <li
                    className={`${noAmount && styles.disabled} ${
                      checked && !noAmount && styles.selected
                    }`}
                  >
                    <div className={styles.imgBox}>
                      <img src={thumbnail} alt="redeemTitle" />
                      {onlyChooseOne && (
                        <div className={styles.radioDiv}>
                          <Radio
                            disabled={noAmount}
                            checked={checked}
                            onClick={() => handleSelect(it, checked)}
                          />
                        </div>
                      )}
                    </div>
                    <div className={styles.detail}>
                      <h4 className={styles.name}>{offerName}</h4>
                      <div>
                        {brief && <p className={styles.commit}>{deleteHtml(brief)}</p>}
                        <Progress percent={percent || 0} showInfo={false} strokeColor="#3434E1" />
                        <p className={styles.numTip}>
                          {noAmount
                            ? GCPI18n({ id: 'lb_sold_out' })
                            : `${availableAmount} ${GCPI18n({ id: 'lb_left_up' })}`}
                        </p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
            <div className={styles.listEnd}>
              <div className={styles.line} />
              <div className={styles.endText}>
                {GCPI18n({ id: 'lb_rewards_the_end_of_the_list' })}
              </div>
              <div className={styles.line} />
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          <Button
            type="primary"
            className={styles.submitBtn}
            onClick={handleSubmit}
            disabled={onlyChooseOne && isEmpty(selectedOffer)}
          >
            {GCPI18n({ id: 'btn_submit' })}
          </Button>
        </div>
      </BaseSpin>
      <Modal
        className={styles.confirmModal}
        breakpoint="mobile"
        size="50%"
        title={null}
        open={confirmVisible}
        showCloseButton={false}
        footer={
          <div className={styles.modalBtns}>
            <Button className={styles.cancel} onClick={handleTryAgain}>
              {GCPI18n({ id: 'btn_cancel' })}
            </Button>
            <Button type="primary" onClick={handleRedeem}>
              {GCPI18n({ id: 'btn_confirm' })}
            </Button>
          </div>
        }
      >
        <span className={styles.tip}>{GCPI18n({ id: 'tip_redeem_voucher' })}</span>
      </Modal>
      {hasFail && (
        <Modal
          breakpoint="mobile"
          size="50%"
          open={hasFail}
          onCancel={() => {
            setHasFail(false);
          }}
          // loading={modalLoading}
          className={styles.failModal}
          footer={
            <div className={styles.failBtns}>
              <Button
                type="primary"
                onClick={() => {
                  setHasFail(false);
                }}
                className={styles.primary}
                style={{ color: '#ffffff' }}
              >
                {GCPI18n({ id: 'lb_dito_failed_page_try_again' })}
              </Button>
              <Button
                className={styles.cancel}
                onClick={() => {
                  onHistoryPush('/pointshop/myVoucher');
                }}
              >
                {GCPI18n({ id: 'lb_point_my_voucher' })}
              </Button>
            </div>
          }
        >
          <div className={styles.contentWrap}>
            <div className={styles.errImg}>
              <img src={convertFail} alt="" />
            </div>
            <div style={{ textAlign: 'center' }}>
              <Text breakpoint="Mobile" size="TitleT23Bold" style={{ fontFamily: 'Roboto' }}>
                {GCPI18n({ id: 'tip_redeem_voucher_fail' })}
              </Text>
              <Text
                breakpoint="Mobile"
                size="ContentC14Regular"
                style={{ fontFamily: 'Roboto', display: 'block', marginTop: '0.16rem' }}
              >
                {GCPI18n({ id: 'tip_redeem_voucher_try_again' })}
              </Text>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default connect(({ pointShop, loading }) => ({
  voucherDetail: pointShop.voucherDetail || {},
  loading:
    loading.effects['pointShop/redeemCoupon'] ||
    loading.effects['pointShop/queryCouponOfferList'] ||
    false,
}))(RedeemList);
